import * as TogglePrimitive from '@radix-ui/react-toggle';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../styles/lib/utils';

const toggleVariants = cva(
  'font-noto inline-flex items-center justify-center gap-1 rounded-[6px] text-xs font-medium leading-5 transition-all cursor-pointer focus-ring disabled:cursor-not-allowed disabled:opacity-50 [&_svg]:shrink-0 whitespace-nowrap',
  {
    variants: {
      variant: {
        default:
          'bg-transparent text-primary-dark hover:bg-grey-20 data-[state=on]:bg-grey-20 data-[state=on]:text-primary',
        outline:
          'border border-grey-30 bg-grey-10 text-primary-dark hover:bg-grey-30 data-[state=on]:bg-blue-10 data-[state=on]:border-blue-50 data-[state=on]:text-blue-60',
        icon: 'text-grey-60 data-[state=on]:text-orange-50 data-[state=on]:hover:text-orange-60',
      },
      size: {
        standard: 'px-2 py-1',
        small: 'px-2 py-0.5',
        icon: 'p-1',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'standard',
    },
  },
);

type ToggleProps = React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> & VariantProps<typeof toggleVariants>;

const Toggle = React.forwardRef<React.ElementRef<typeof TogglePrimitive.Root>, ToggleProps>(
  ({ className, variant, size, ...props }, ref) => (
    <TogglePrimitive.Root
      ref={ref}
      data-slot="toggle"
      className={cn(toggleVariants({ variant, size }), className)}
      {...props}
    />
  ),
);

Toggle.displayName = 'Toggle';

export { Toggle, toggleVariants };
export type { ToggleProps };
